/**
 * Detect the width of the scrollbar for the current browser. This is most often useful for making
 * sure that column headers align with cell contents when using <FixedSizeList> from react-window
 * in conjunction with react-table. See example in: packages/web/src/components/pages/Works/components/WorksTable/WorksTable.tsx
 * Based on: https://davidwalsh.name/detect-scrollbar-width
 */
export const getScrollbarWidth = (): number => {
    const scrollDiv = document.createElement('div');

    scrollDiv.setAttribute(
        'style',
        'width: 100px; height: 100px; overflow: scroll; position:absolute; top:-9999px;',
    );

    document.body.appendChild(scrollDiv);

    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

    document.body.removeChild(scrollDiv);

    return scrollbarWidth;
};
